import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="w-full px-4 md:px-8 py-24 flex flex-col items-center text-center">
      <span className="font-heading text-6xl md:text-8xl font-bold text-primary-500">404</span>
      <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-500 max-w-md">
        你访问的页面不存在或已被移除。不如回到首页，继续发现精彩的高清影视内容。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-100 text-foreground-700 text-sm font-medium whitespace-nowrap hover:bg-background-200 transition-colors"
        >
          <i className="ri-search-line" /> 去搜索
        </Link>
      </div>
    </div>
  );
}